<template>
  <div class="crud_module--rsr_reset_charger">
    <el-button type="info" @click="rsrResetCharger">{{
      $t("label.get_giagnostics")
    }}</el-button>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {},
  async beforeMount() {
    this.key = this.$route.params.key;
    this.id = this.$route.params.id;
  },
  methods: {
    async rsrResetCharger() {
      let action = this.$t("label.get_giagnostics");
      let message = this.$t("message.confirm_start_charger", {action : action});
      let confirm = await this.$confirm(message, message, {
        confirmButtonText: action,
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!confirm) return;

      await this.$axios
        .get(`/${this.key}/getDiagnostics/${this.id}`, {})
        .then((res) => {
          if (res.data?.status == "success") {
            this.$message({
              message: this.$t("success"),
              type: "success",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: this.$t("error.generic"),
            type: "error",
          });
          return false;
        });
    },
  },
  data() {
    return {
      key: "",
      id: 0,
      loading: false,
      connectors: [],
      input: {
        connectorId: 0,
        duration: 0,
        startCode: "",
        lp: "",
        entryTime: "",
      },
    };
  },
};
</script>

<style lang="scss">
.crud_module--rsr_reset_charger {
  display: inline-block;
  margin-top: 10px;
  margin-left: 10px;
  .el-button--info {
    background-color: #909399;
  }
}
</style>
